import { render, staticRenderFns } from "./demoList.vue?vue&type=template&id=32dd777d&scoped=true&"
import script from "./demoList.vue?vue&type=script&lang=js&"
export * from "./demoList.vue?vue&type=script&lang=js&"
import style0 from "./demoList.vue?vue&type=style&index=0&id=32dd777d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd777d",
  null
  
)

export default component.exports